import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "translation/useTranslation";

export default function Users() {
  const { translate, editableTranslate } = useTranslation();

  return (
    <>
      <div className="col-lg col-md-9 section-col-right d-flex">
        <div className={`bg-white w-100 p-4 content-card`}>
          <h4>{editableTranslate('global.menu.initial_setup.users', 'Login Benutzende')}</h4>

          <div className="mt-4">
            {/* form with How shall login users be managed, radio button automatic, manual */}
            <div className="form-group">
              <label>{editableTranslate('initial_setup.users.how_to_login', 'Wie soll das Login der Benutzenden verwaltet werden?')}</label>
              <div className="form-check">
                <input className="form-check-input" type="radio" name="loginManagement" id="automatic" value="automatic" data-testid="login-management-automatic" />
                <label className="form-check-label ml-2" htmlFor="automatic">
                  {editableTranslate('initial_setup.users.how_to_login.automatic', 'Automatisch (LDAP)')}
                </label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="radio" name="loginManagement" id="manual" value="manual" data-testid="login-management-manual" />
                <label className="form-check-label ml-2" htmlFor="manual">
                  {editableTranslate('initial_setup.users.how_to_login.manual', 'Manuell (CSV)')}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
